/**
 * https://tc39.es/ecma402/#sec-getoptionsobject
 * @param options
 * @returns
 */
export function GetOptionsObject(options) {
  if (typeof options === 'undefined') {
    return Object.create(null);
  }
  if (typeof options === 'object') {
    return options;
  }
  throw new TypeError('Options must be an object');
}